import { render, staticRenderFns } from "./StoreSummary.vue?vue&type=template&id=597623ba"
import script from "./StoreSummary.vue?vue&type=script&lang=js"
export * from "./StoreSummary.vue?vue&type=script&lang=js"
import style0 from "./StoreSummary.vue?vue&type=style&index=0&id=597623ba&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports